import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { AuthService } from '../auth.service';
import { NgForm } from '@angular/forms';
import { UserModel } from '../models/user.model';
import { UIRouter } from '@uirouter/core';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: './profile.component.html',
  styleUrls: [
    './profile.component.scss'
  ]
})
export class AuthProfileComponent implements OnInit, OnDestroy {
  private currentUserSub: Subscription;

  public user: UserModel;

  public password = {
    old: '',
    new: '',
    repeat: ''
  };

  public isSuccess: boolean = false;
  public isError: boolean = false;

  public isPasswordChangeSuccess: boolean = false;
  public isPasswordChangeError: boolean = false;

  public passwordChangeErrorCode: string;

  public displayNameOptions: { anonymous: string, name?: string } = {
    anonymous: 'Anonymer Spender'
  };

  constructor(
    private authService: AuthService,
    private router: UIRouter
  ) {

  }

  public ngOnInit() {
    this.user = Object.assign({}, this.authService.currentUser);

    this.currentUserSub = this.authService.currentUserChange.subscribe(
      (result) => {
        if (!result) {
          this.router.stateService.go('main.home');
        } else {
          this.user = Object.assign({}, result);

          this.displayNameOptions = {
            name: this.user.screenName,
            anonymous: 'Anonymer Spender'
          };
        }
      }
    );

    this.displayNameOptions = {
      name: this.user.screenName,
      anonymous: 'Anonymer Spender'
    };
  }

  public ngOnDestroy() {
    this.currentUserSub.unsubscribe();
  }

  public compileCreditName() {
    if (this.user.firstName && this.user.lastName) {
      this.user.creditName = this.user.firstName + ' ' + this.user.lastName.charAt(0) + '.';

      this.displayNameOptions = {
        name: this.user.creditName,
        anonymous: 'Anonymer Spender'
      };

      this.user.options.displayName = 'name';
    } else {
      this.user.creditName = '';

      if (this.displayNameOptions.name) {
        this.displayNameOptions = {
          anonymous: 'Anonymer Spender'
        };

        this.user.options.displayName = 'anonymous';
      }
    }
  }

  public hasError(form: NgForm, field: any, type: string = 'required', excludeIf?: string[]) {
    let hasError = field.invalid &&
      form.submitted &&
      field.errors &&
      field.errors[type];

    if (excludeIf) {
      for (const exclude of excludeIf) {
        if (field.errors && field.errors[exclude]) {
          hasError = false;
          break;
        }
      }
    }

    return hasError;
  }

  public handleSubmit(form: NgForm) {
    this.isSuccess = false;
    this.isError = false;

    if (form.valid) {
      this.authService.updateCurrentUserAttributes(this.user)
        .subscribe(
          () => {
            this.authService.getCurrentUser();

            this.isSuccess = true;
          },
          (err) => {
            this.isError = true;
          }
        );
    }
  }

  public handleChangePasswordSubmit(form) {
    this.isPasswordChangeSuccess = false;
    this.isPasswordChangeError = false;

    if (form.valid) {
      this.authService.changePassword(this.password.old, this.password.new)
        .subscribe(
          () => {
            this.isPasswordChangeSuccess = true;
          },
          (err) => {
            this.isPasswordChangeError = true;

            if (err.code === 'NotAuthorizedException') {
              this.passwordChangeErrorCode = err.code;
            } else {
              this.passwordChangeErrorCode = 'GenericException';
            }
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/profile/profile.component.ts